/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { AppBarProfileButtonComponent } from './app-bar-profile-button';
export * from './app-bar-profile-button-adapter';
export * from './app-bar-profile-button-constants';
export * from './app-bar-profile-button-core';
export * from './app-bar-profile-button';
export function defineAppBarProfileButtonComponent() {
    defineCustomElement(AppBarProfileButtonComponent);
}
